// extracted by mini-css-extract-plugin
export var errorContainer = "styles-module__errorContainer___Kv64g";
export var tabBar = "styles-module__tabBar___QfLBx";